<pxc-sync-center-button
  [items]="items()"
  (deleteChild)="onDeleteChild($event)"
  (resumeChild)="onResumeChild($event)"
  (retryChild)="onRetryChild($event)" />
